import * as Yup from "yup";

import { InsuranceCoverage } from "Store/interfaces/products/coverage";
import { AkaHouseContentsProductPriceFormValues } from "../akaHouseContentsFormValuesInterfaces";

export const validationSchema =
  (): Yup.ObjectSchema<AkaHouseContentsProductPriceFormValues> => {
    return Yup.object({
      coverage: Yup.mixed<InsuranceCoverage>().required(),
    }).defined();
  };
